<template>
  <v-app>
    <Header/>
    <Sidebar v-if="isAdministrator"/>
    <Dashboard v-if="isAdministrator"/>
    <Todo v-if="!isAdministrator"/>
    <Footer/>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Dashboard from '../components/Dashboard'
import Todo from '../components/Todo'
import Footer from '../components/Footer'
import Maps from '../components/Maps'
export default {
  name: 'Main',
  components: { Header, Sidebar, Dashboard, Todo, Footer, Maps },
  created: function () {
    this.$store.dispatch('page/setTitle', {title: ''})
  },
  data () {
    return {
    }
  },
  computed: {
    isAdministrator: function () {
      return this.$store.getters['session/hasAdministratorRole']
    }
  }
}
</script>

<style>
  html {
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Main.vue